import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification } from "hooks/useNotification";
import { useState } from "react";
import {
  deleteTransportSedelWaste,
  DeleteTransportSedelWasteInput,
  TransportSedelQueryKey,
} from "api/transportSedel.api";
import { UppdragQueryKey } from "api/uppdrag.api";

export const useDeleteWasteLogic = () => {
  const queryClient = useQueryClient();
  const notification = useNotification();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const onModalClose = () => setIsModalOpen(false);

  const mutation = useMutation({
    ...deleteTransportSedelWaste(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [UppdragQueryKey.GetOne],
      });
      queryClient.invalidateQueries({
        queryKey: [TransportSedelQueryKey.GetList],
      });
      onModalClose();
    },
    onError: () => notification.error(),
  });

  const onConfirm = (input: DeleteTransportSedelWasteInput) =>
    mutation.mutate(input);

  return {
    isModalOpen,
    openModal: () => setIsModalOpen(true),
    onConfirm,
    mutation,
    onModalClose,
  };
};

export type DeleteWasteLogicRetVal = ReturnType<typeof useDeleteWasteLogic>;
